import { useStyles } from '@archipro-design/aria';
import {
    COLUMN_WIDTH_100,
    DUO_COLUMN_WIDTH,
} from '@modules/page-builder/config/column-constants';
import type { ImageColumnProps } from '@modules/page-builder/types';
import DetailSingleImage from '../detail-single-image-shell/DetailSingleImageShell';
import { SingleImageContainer } from '../../common/pagebuilder.style';
import { getImagesSizes } from '~/utils/image-sizes-utils';
import ImageWithPaintPicker from '../../common/image-with-paint-picker/ImageWithPaintPicker';
import { ImageModuleExtraSpacing } from '../detail-modules/DetailModules.style';

interface SingleImageModuleProps {
    column: ImageColumnProps;
    isProject?: boolean;
    isProjectRevamp?: boolean;
}

const SingleImageModule = ({
    column,
    isProject,
    isProjectRevamp,
}: SingleImageModuleProps) => {
    const { css } = useStyles({ isProjectRevamp });

    if (!column.imageUrl) {
        return null;
    }
    // If the image is smaller than the 1440px width from duo column,
    // then its a medium image instead of a full width one.
    const isMedium = column.dimension.width < DUO_COLUMN_WIDTH;

    return (
        <div className={css(SingleImageContainer, ImageModuleExtraSpacing)}>
            <DetailSingleImage
                caption={column.caption}
                libraryImage={column?.libraryImage}
                tags={column.tags}
                uniqueApprovedTags={column.uniqueApprovedTags}
                imageURL={column.imageUrl}
                dimension={column.dimension}
                columnId={column.id}
                moduleType={
                    isMedium ? 'MediumSingleImageModule' : 'SingleImageModule'
                }
                isProject={isProject}
                isProjectRevamp={isProjectRevamp}
            >
                <ImageWithPaintPicker
                    src={column.imageUrl}
                    width={column.dimension.width}
                    height={column.dimension.height}
                    layout={'fill'}
                    objectFit={'cover'}
                    sizes={getImagesSizes(COLUMN_WIDTH_100)}
                    alt={column.caption || column?.libraryImage?.Title || ''}
                    className="overflow-hidden md:rounded-2"
                />
            </DetailSingleImage>
        </div>
    );
};

export default SingleImageModule;
